/* unplugin-vue-components disabled */import { render } from "./IdeUpload.vue?vue&type=template&id=e23c68c2&scoped=true"
import script from "./IdeUpload.vue?vue&type=script&lang=js"
export * from "./IdeUpload.vue?vue&type=script&lang=js"

import "./IdeUpload.vue?vue&type=style&index=0&id=e23c68c2&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23c68c2"]])

export default __exports__